import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  Mensagem,
  MensagemParametrosRequest,
  MensagemReenvioResposta,
} from './mensagem.dto';
import { Pagina } from './pagina';

/**
 * Registro de mensagens enviadas. **Todas as rotas exigem perfil admin**, e aqui o backend
 * confere isso no servidor (`403` para quem está autenticado sem o perfil) — diferente do resto
 * da API, onde o gate é só de navegação (`PEND-09`).
 */
@Injectable({ providedIn: 'root' })
export class MensagemService {
  private readonly apiUrl = `${environment.api}/mensagens`;

  constructor(private http: HttpClient) {}

  /**
   * `filtro` é trecho do e-mail ou do nome (catequizando, mãe, pai) da pré-inscrição de origem,
   * sem caixa e sem acento. `CTR-12` — vazio não entra.
   */
  listar(page: number, size: number, filtro?: string, sort?: string | null): Observable<Pagina<Mensagem>> {
    let params = new HttpParams().set('page', page).set('size', size);
    if (filtro && filtro.trim() !== '') params = params.set('filtro', filtro.trim());
    if (sort) params = params.set('sort', sort);
    return this.http.get<Pagina<Mensagem>>(this.apiUrl, { params });
  }

  buscarPorId(id: string): Observable<Mensagem> {
    return this.http.get<Mensagem>(`${this.apiUrl}/${encodeURIComponent(id)}`);
  }

  /** Atualização **parcial**: mande só o que mudou. */
  atualizarParametros(id: string, parametros: MensagemParametrosRequest): Observable<Mensagem> {
    return this.http.put<Mensagem>(`${this.apiUrl}/${encodeURIComponent(id)}/parametros`, parametros);
  }

  /**
   * Reenvia. Sem `destinatario`, vai para o mesmo. O reenvio **não** cria registro nem altera a
   * mensagem original — é diagnóstico.
   */
  reenviar(id: string, destinatario?: string): Observable<MensagemReenvioResposta> {
    const corpo = destinatario?.trim() ? { destinatario: destinatario.trim() } : {};
    return this.http.post<MensagemReenvioResposta>(
      `${this.apiUrl}/${encodeURIComponent(id)}/reenviar`,
      corpo,
    );
  }
}
